import { createSvgIcon } from "@mui/material";

export const EditIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M15.5 5.5L18.3284 8.32843M3.00025 20.9998L3.0477 20.6676C3.21561 19.4922 3.29956 18.9045 3.49053 18.3559C3.65999 17.869 3.89149 17.406 4.17931 16.9783C4.50366 16.4963 4.92344 16.0766 5.76299 15.237L17.411 3.58902C18.192 2.80797 19.4584 2.80797 20.2394 3.58902C21.0205 4.37007 21.0205 5.6364 20.2394 6.41745L8.37769 18.2792C7.61604 19.0408 7.23522 19.4216 6.80144 19.7245C6.41642 19.9933 6.00117 20.216 5.56422 20.388C5.07195 20.5818 4.544 20.6883 3.48817 20.9013L3.00025 20.9998Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>,
    'EditIcon'
)
